const KeenSlider = window.KeenSlider

const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins

class FeaturedProducts extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.1,
          spacing: 20,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2.2,
              spacing: 20,
            },
          },
          '(min-width: 901px)': {
            slides: {
              perView: 3.25,
              spacing: 20,
            },
          },
          '(min-width: 1201px)': {
            disabled: true,
          },
        },
      },
      [setInitialised(), addWheelControls('horizontal')],
    )
  }
}

if (!customElements.get('featured-products')) {
  customElements.define('featured-products', FeaturedProducts)
}
